<template>
  <div>
    <!-- <survey-selected-chart
      v-for="(q, index) in selectedQuestions"
      :key="(q || {}).id || index"
      :item-id="(q || {}).id"
      :item-title="(q || {}).label"
      :tooltip-title="tooltipTitle"
      @click="$emit('remove-question', q)"
    />
    <template v-if="isProfileVisible">
      <survey-selected-chart
        v-for="(dv, index) in derivedVars"
        :key="dv.title || index"
        :item-id="`dv_${index}`"
        :item-title="(dv || {}).title"
        :tooltip-title="tooltipTitle"
        @click="$emit('remove-der-var', dv)"
      />
    </template> -->
    
    <survey-selected-chart
      v-for="(item, index) in mergedItems"
      :key="item.q_type === 'question' ? (item.id || index) : (item.title || index)"
      :item-id="item.q_type === 'question' ? item.id : `dv_${index}`"
      :item-title="item.q_type === 'question' ? item.label : item.title"
      :tooltip-title="tooltipTitle"
      @click="handleItemClick(item)"
    />
 

  </div>
</template>

<script>
import DerivedVariables from '@/providers/DerivedVariables';
import SurveySelectedChart from '@/components/survey/SurveySelectedChart';
import {isQuestionAvailableOnResultsForQuestionnaire} from '@/helpers/questionnaireHelper';

export default {
  name: 'SurveySelectedCharts',
  components: {
    SurveySelectedChart,
  },
  props: {
    comparison: {
      type: Object,
      required: true,
    },
    questions: {
      required: true,
      type: [Array, Object],
    },
    questionnaire: {
      type: Object,
      required: true,
    },
    tooltipTitle: {
      type: String,
    },
    isProfileVisible: {
      type: Boolean,
      default: true,
    },
    resultsSorted: {
      default:[]
    }
  },
  computed: {
    mergedItems: function() {
      const merged = [];

      // Add selected questions
      if (this.comparison && this.questions) {
        const questionIds = (this.comparison.charts || {}).questionIds || [];
        
        const commonIds = Object.values(this.questions).filter(item1 => {
        return this.resultsSorted.some(item2 => {
          return item1.id === item2.id;
        });
      });

        const sortedQuestions = commonIds
          .filter(({ id }) => questionIds.includes(id) && isQuestionAvailableOnResultsForQuestionnaire(id, this.questionnaire))
          .sort((a, b) => {
            const indexA = this.resultsSorted.findIndex(item => item.id === a.id);
            const indexB = this.resultsSorted.findIndex(item => item.id === b.id);
            return indexA - indexB;
        });

         
        const modifiedQuestions = sortedQuestions.map((q) => ({
            ...q,
            q_type: 'question',
            visible: true
        }));
        merged.push(...modifiedQuestions);
      }

      // Add derived variables
      if (this.comparison && this.isProfileVisible) {
        const derivedVars = this.comparison.charts.derivedVarNames.map((dvName) => {
          const derivedVar = this.dvVariables[dvName];
          return {
              ...derivedVar,
              q_type: 'profile',
              visible: this.isProfileVisible
          };
        });
       
        merged.push(...derivedVars);
      }
  

      const valueMap = this.resultsSorted.reduce((map, item) => {
        map[item.key] = item.value;
        return map;
      }, {});
      merged.sort((a, b) => {
        const aValue = valueMap[a.name || a.id];
        const bValue = valueMap[b.name || b.id];
        if (a.name !== undefined && b.name !== undefined) {
          return (aValue || 0) - (bValue || 0);
        }

        if (a.name !== undefined) return -1;
        if (b.name !== undefined) return 1;

        return (aValue || 0) - (bValue || 0);
      });

      // const sortOrderMap = new Map(this.resultsSorted.map((item, index) => [item.id, index]));
      // merged.sort((a, b) => {
      //     const indexA = sortOrderMap.get(a.id || a.name);
      //     const indexB = sortOrderMap.get(b.id || b.name);
      //     return indexA - indexB;
      // });
      return merged;
    },
    dvVariables: function () {
      return DerivedVariables.userFilterVariables;
    },
    selectedQuestions: function() {
      if (!this.comparison || !this.questions) {
        return [];
      }
      const questionIds = (this.comparison.charts || {}).questionIds || [];
      return Object.values(this.questions).filter(
        ({ id }) =>
          questionIds.includes(id) &&
          isQuestionAvailableOnResultsForQuestionnaire(id, this.questionnaire)
      );
    },
    derivedVars: function() {
      if (!this.comparison) {
        return [];
      }
      return this.comparison.charts.derivedVarNames.map((dvName) => {
        return this.dvVariables[dvName];
      });
    },
  },
  methods: {
    handleItemClick(item) {
      if (item.q_type === "question") {
        this.$emit('remove-question', item);
      } else if(item.q_type === "profile") {
        this.$emit('remove-der-var', item);
      }
    },
  },
  watch: {
    resultsSorted: {
      handler() {

      },
      immediate: true, // Trigger the handler immediately upon component creation
      deep: true // Watch for changes deeply in the array
    }
  }
};
</script>

<style scoped></style>
